import { pick } from 'lodash';
export class OrganizedTreeService {
  getMediaTreeObject(m) {
    return {
      text: m.title || m.text,
      slug: m.slug,
      type: m.type,
      icon: 'fas fa-tv',
      dropDisabled: true,
    };
  }
  getFolderTreeObject(m) {
    return {
      text: m.text,
      slug: m.slug,
      type: 'folder',
      icon: null,
      children: [],
    };
  }
  getNewTree(media, collection_name) {
    return [
      {
        text: collection_name,
        type: 'root',
        dragDisabled: true,
        children: media.map(m => this.getMediaTreeObject(m)),
        opened: true,
      },
    ];
  }
  getExistingTree(children, collection_name) {
    return [
      {
        text: collection_name,
        type: 'root',
        dragDisabled: true,
        children: children,
        opened: true,
      },
    ];
  }

  generateNewFolderSlug(node) {
    let allSlugs = [];
    this.findAllSlugs(node, allSlugs);

    let slug = 'new-node';
    let counter = 1;
    while (allSlugs.includes(slug)) {
      slug = 'new-node' + '-' + counter++;
    }
    console.log(allSlugs);
    console.log(slug);
    return slug;
  }

  findAllSlugs(node, result) {
    if (Array.isArray(node)) {
      node.forEach(n => this.findAllSlugs(n, result));
    } else if (node.children && node.children.length > 0) {
      node.children.forEach(n => this.findAllSlugs(n, result));
    } else if (node.slug) {
      result.push(node.slug);
    }
  }

  formatTreeDataToOrganizedCollection(tree) {
    let propertiesToKeep = ['text', 'description', 'slug', 'type', 'icon', 'dropDisabled', 'children'];
    let processed = pick(tree, propertiesToKeep);
    if (processed && processed.children.length > 0) {
      processed.children.forEach((child, index) => {
        processed.children[index] = this.formatTreeDataToOrganizedCollection(child, processed);
      });
    }
    return processed;
  }

  getAllCheckedMediaInTree(node, tree) {
    if (Array.isArray(node)) {
      node.forEach(n => this.getAllCheckedMediaInTree(n, tree));
    } else if (node.children && node.children.length > 0) {
      node.children.forEach(n => this.getAllCheckedMediaInTree(n, tree));
    } else if (node.selected && (node.type !== 'folder' || node.type !== 'root')) {
      tree.push(node);
    }
  }

  getCheckedNodesInTree(node, tree) {
    if (Array.isArray(node)) {
      node.forEach(n => this.getCheckedNodesInTree(n, tree));
    } else if (node.children && node.children.length > 0) {
      node.children.forEach(n => this.getCheckedNodesInTree(n, tree));
    } else if (node.selected) {
      tree.push(node);
    }
  }

  getAllMediaInTree(node, tree) {
    if (Array.isArray(node)) {
      node.forEach(n => this.getAllMediaInTree(n, tree));
    } else if (node.slug && node.type !== 'folder') {
      tree.push(node);
    } else if (node.children && node.children.length > 0) {
      node.children.forEach(n => this.getAllMediaInTree(n, tree));
    }
  }

  getAllCheckedNodesInTree(node, tree) {
    if (Array.isArray(node)) {
      node.forEach(n => this.getAllCheckedNodesInTree(n, tree));
      return;
    }

    let data = node.data ? node.data : node;

    if (data.selected) {
      tree.push(node);
    } else if (node.$children && node.$children.length > 0) {
      node.$children.forEach(n => this.getAllCheckedNodesInTree(n, tree));
    }
  }

  deleteNode(slug, obj, parent) {
    if (Array.isArray(obj)) {
      obj.forEach(n => this.deleteNode(slug, n, obj));
    } else if ('slug' in obj && obj.slug == slug) {
      let index = parent.children.findIndex(c => c.slug === slug);
      parent.children.splice(index, 1);
    } else if (obj.children) {
      obj.children.forEach(c => this.deleteNode(slug, c, obj));
    }
  }

  buildCollectionFromSelectedNodes(node, tree) {
    if (Array.isArray(node)) {
      node.forEach(n => this.buildCollectionFromSelectedNodes(n, tree));
    }

    if (node.type === 'root') {
      node.children.forEach(n => this.buildCollectionFromSelectedNodes(n, tree));
      return;
    }

    // If media and selected push to tree
    if (node.type !== 'folder' && node.selected) {
      tree.push(this.getMediaTreeObject(node));
      return;
    }

    // If folder and not selected go to child
    if (node.type === 'folder' && !node.selected) {
      node.children.forEach(n => this.buildCollectionFromSelectedNodes(n, tree));
      return;
    }

    // If folder and selected push to tree and go to child with pushed node
    if (node.type === 'folder' && node.selected) {
      let length = tree.push(this.getFolderTreeObject(node));
      node.children.forEach(n => this.buildCollectionFromSelectedNodes(n, tree[length - 1].children));
      return;
    }
  }
}
